// libraries
import React from 'react';
import PropTypes from 'prop-types';
import {Route, Switch} from 'react-router';
import {ConnectedRouter} from 'react-router-redux';

// components
import Login from '../../login/containers/login';
import SignUp from '../../sign-up/containers/signup';
import Terms from 'terms-of-use/containers';
import CopyrightPolicy from 'copyright-policy/containers';
import Policy from 'privacy-policy/containers/';
import ErrorMessageAndRedirect from 'shared/components/error-message-and-redirect';

// shared
import Notifications from 'shared/components/notifications';

const CLEVER_ERROR_MESSAGE = 'Something went wrong while trying to connect to Clever, please try again or log in ' +
                             'with your email and password';

const ShowCleverError = () => (
  <ErrorMessageAndRedirect message={CLEVER_ERROR_MESSAGE} redirectTo="/signup" />
);

class RootApp extends React.Component {
  static propTypes = {
    browserHistory: PropTypes.object.isRequired
  }

  render () {
    const {browserHistory} = this.props;

    return (
      <ConnectedRouter history={browserHistory}>
        <React.Fragment>
          <Notifications />
          <Switch>
            <Route path="/login" component={Login} />
            <Route path="/signup/clever-error" component={ShowCleverError} />
            <Route path="/signup" component={SignUp} />
            <Route path="/terms_of_use" component={Terms} />
            <Route path="/copyright_policy" component={CopyrightPolicy} />
            <Route path="/privacy_policy" component={Policy} />
          </Switch>
        </React.Fragment>
      </ConnectedRouter>
    );
  }
}

export default RootApp;
